import React from "react";
import styles from "./styles.module.scss";
import { cls } from "app/utils";
interface Props {
  label: string;
  labelClassName?: string;
  icon?: React.ReactNode;
  isActive?: boolean;
  onClick?: () => void;
  className?: string;
  ref?: React.RefObject<HTMLDivElement>;
  badge?: React.ReactNode;
  'data-testid'?: string;
}

const TabButton = ({
  label,
  labelClassName,
  icon,
  className,
  isActive,
  onClick,
  ref,
  badge,
  'data-testid': testId,
}: Props) => {
  return (
    <div
      ref={ref}
      className={cls(styles.tab_button, className, {
        [styles.active]: isActive,
      })}
      onClick={onClick}
      data-testid={testId}
    >
      {icon && icon}
      <p className={labelClassName}>{label}</p>
      {badge && badge}
    </div>
  );
};

export default TabButton;
